import { Hero } from '@/components/landing/Hero';
import { Services } from '@/components/landing/Services';
import { Journey } from '@/components/landing/Journey';
import { RiskFree } from '@/components/landing/RiskFree';
import { ClientLogos } from '@/components/landing/ClientLogos';
import { TrustedBy } from '@/components/landing/TrustedBy';
import { Focus } from '@/components/landing/Focus';
import { Positioning } from '@/components/landing/Positioning';
import { Comparison } from '@/components/landing/Comparison';
import { HowItWorks } from '@/components/landing/HowItWorks';
import { Trust } from '@/components/landing/Trust';
import { Founders } from '@/components/landing/Founders';
import { Testimonials } from '@/components/landing/Testimonials';
import { Pricing } from '@/components/landing/Pricing';
import { Faq } from '@/components/landing/Faq';
import { Cta } from '@/components/landing/Cta';

/**
 * Une page d'agence : qui on est et ce qu'on prend en charge d'abord (hero,
 * services, puis du post à l'opportunité), puis une section par visiteur — le sceptique lit la méthode, le
 * prudent lit « zéro risque », le fondateur qui lance lit Focus, celui qui
 * connaît les pods lit le comparatif,
 * l'inquiet lit Trust, celui qui veut savoir à qui il parle lit l'équipe, le
 * comparateur de prix lit Pricing.
 */
export function Landing() {
  return (
    <>
      <Hero />
      <TrustedBy />
      <Services />
      <Journey />
      <HowItWorks />
      <RiskFree />
      <Focus />
      <Positioning />
      <Comparison />
      <Trust />
      <Founders />
      <Testimonials />
      <Pricing />
      <Faq />
      <Cta />
      <ClientLogos />
    </>
  );
}
